import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import MobileCampaignReport from './MobileCampaignReport';
import OverheadCampaignReport from './OverheadCampaignReport';
import Layout from '../../../layout/Layout';

const CampaignReportsAccordion = () => {
    return (
        <Layout>
            <h5 className="report-heading">Select Reports to View</h5>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Mobile Campaign Reports</Accordion.Header>
                    <Accordion.Body>
                        <MobileCampaignReport />
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>In-Gym Campaign Reports</Accordion.Header>
                    <Accordion.Body>
                        <OverheadCampaignReport />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Layout>
    );
};

export default CampaignReportsAccordion;
